export default [
  '1-9 years',
  '10-14 years',
  '15-19 years',
  '20-24 years',
  '25+ years'
];



// WEBPACK FOOTER //
// ./shared/common/staticData/industryYearsExperienceList.js